export const CollectionNames = {
  auditLog: 'auditLog', /* Note: this is not currently used */
  categories: 'categories',
  companies: 'companies',
  subscribers: 'subscribers',
  suggestedCompanies: 'suggestedCompanies',
  tags: 'tags'
};
